interface RaceSort {
  startDate?: Date | null
  displayOrder?: number | null
}

export const raceSort = (a: RaceSort, b: RaceSort) => {
  const displayOrderA = a.displayOrder ?? Number.MAX_SAFE_INTEGER
  const displayOrderB = b.displayOrder ?? Number.MAX_SAFE_INTEGER

  if (displayOrderA !== displayOrderB) {
    return displayOrderA - displayOrderB
  }

  if (a.startDate && b.startDate) {
    const dayA = new Date(a.startDate).setHours(0, 0, 0, 0)
    const dayB = new Date(b.startDate).setHours(0, 0, 0, 0)

    if (dayA !== dayB) {
      return dayA - dayB
    }

    return a.startDate.getTime() - b.startDate.getTime()
  }

  return a.startDate ? 1 : -1
}
